import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "decisionField", "resultsDialog", "confirmDialog", "confirmMessage"]
  static values = { successCount: Number, duplicateCount: Number }

  confirmDecision(event) {
    const decision = event.params.decision
    this.decisionFieldTarget.value = decision
    this.confirmMessageTarget.textContent = this.messageFor(decision)
    this.resultsDialogTarget.classList.add("hidden")
    this.confirmDialogTarget.classList.remove("hidden")
    this.confirmDialogTarget.classList.add("flex")
  }

  cancelConfirmation() {
    this.confirmDialogTarget.classList.add("flex")
    this.confirmDialogTarget.classList.add("hidden")
    this.resultsDialogTarget.classList.remove("hidden")
  }

  submit() {
    this.formTarget.requestSubmit()
  }

  close() {
    this.element.classList.add("hidden")
  }

  messageFor(decision) {
    switch (decision) {
      case "reject":
        return "This will discard the entire import. No members will be created or updated."
      case "accept_success":
        return `This will create or update ${this.successCountValue} member(s). Rows with possible duplicates or errors will be skipped.`
      case "accept_all":
        return `This will create or update ${this.successCountValue + this.duplicateCountValue} member(s), including rows flagged as possible duplicates.`
      default:
        return "Are you sure you want to proceed?"
    }
  }
}